import { ProtocolKey } from "@silo/types";
import { Config, Effect, pipe } from "effect";
import { getProtocolStaticMarketsFileName } from "./utils";
import {
  HttpClient,
  HttpClientRequest,
  HttpClientResponse,
} from "@effect/platform";
import { StaticMarketsFile } from "./types";

export type GetProtocolStaticMarkets = ReturnType<
  typeof getProtocolStaticMarkets
>;
export type GetProtocolStaticMarketsSuccess =
  Effect.Effect.Success<GetProtocolStaticMarkets>;
export type GetProtocolStaticMarketsError =
  Effect.Effect.Error<GetProtocolStaticMarkets>;
export type GetProtocolStaticMarketsContext =
  Effect.Effect.Context<GetProtocolStaticMarkets>;

export function getProtocolStaticMarkets(protocolKey: ProtocolKey) {
  return Effect.gen(function* () {
    const BLOB_URL_V1 = yield* Config.string("BLOB_URL_V1");
    const fileName = yield* getProtocolStaticMarketsFileName(protocolKey);

    const { data: staticMarkets } = yield* pipe(
      HttpClientRequest.get(`${BLOB_URL_V1}/${fileName}`),
      HttpClient.fetch,
      Effect.andThen(HttpClientResponse.schemaBodyJson(StaticMarketsFile)),
      Effect.scoped
    );

    return staticMarkets;
  });
}
